import { $body } from '../Constants';
import HtmlElement from './HtmlElement';

/**
 * RegionSelector
 */
const RegionSelector = (() => {
  /**
   * Selector
   */
  const Selector = {
    REGION_SELECTOR: '.region-selector',
	CLOSE: '.region-selector-content-close',
	OVERLAY: '.region-selector-overlay'
  };

  /**
   * RegionSelector
   *
   * @class
   * @augments HtmlElement
   */
  class RegionSelector extends HtmlElement {
    // Public

    /**
     * Handles ready event
     *
     * @return void
     */
    onReady() {
		const currentRegion = this.$element.data('region');
		const params = new URLSearchParams(window.location.search);
		const currentDeeplLanguage = params.get('deepl');
		this.$close = this.$element.find(Selector.CLOSE);
		this.$languages = this.$element.find('.region-selector-region-languages');

		const $defaultLanguage = this.$languages.find(`a[data-default="1"][data-region="${currentRegion}"]`);

		if (!currentDeeplLanguage) {
			$defaultLanguage.addClass('current');
		} else {
			const $a = this.$languages.find(`a[hreflang="${currentDeeplLanguage}"][data-region="${currentRegion}"]`);

			if ($a.length) {
				$a.addClass('current');
			} else {
				$defaultLanguage.addClass('current');
			}
		}

		this.$close.on('click', () => {
			this.close();
		});

		this.$element.find(Selector.OVERLAY).on('click', () => {
			this.close();
		});
    }

	close() {
		this.$element.find('input[id^="toggle-region-selector"]').prop('checked', false);
	}
  }

  return RegionSelector._getElements($body.find(Selector.REGION_SELECTOR), RegionSelector);
})();

export default RegionSelector;
